module.exports = __webpack_public_path__ + "img/icon-success.cab9535b.svg";